import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

:host {
  display: inline-flex;
}

.preview-wrapper {
  width: 93px;
  height: 93px;
  border-radius: 0.5rem;
  border: 1px solid var(--atlas-primary);
  transition: box-shadow 0.25s ease;
  box-sizing: border-box;
}
.preview-wrapper .preview-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 0.5rem;
}

.preview {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  border: 0;
}
.preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview .preview-overlay {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
.preview .preview-badge,
.preview .preview-progress {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.25s ease;
  opacity: 1;
  z-index: 3;
}
.preview .preview-progress {
  width: calc(100% - 1rem);
}
.preview.show-badge .preview-badge {
  display: block;
}
.preview.show-progress .preview-progress {
  display: block;
}
.preview:focus-visible {
  outline: none;
}

.preview-toolbar {
  display: flex;
  position: absolute;
  top: 0.5rem;
  left: 50%;
  background: #ffffff;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  transition: visibility 0.25s ease, transform 0.25s ease;
  transform: translate(-50%, calc(-100% - 0.5rem));
  z-index: 4;
  visibility: hidden;
}

.preview-toolbar-button {
  margin: 0;
  border: 0;
  padding: 0.5rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  cursor: pointer;
  color: var(--atlas-secondary);
  transition: background 0.25s ease, color 0.25s ease;
}
.preview-toolbar-button:hover {
  background: var(--atlas-secondary-100);
}
.preview-toolbar-button:focus-visible {
  z-index: 2;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}

.preview-file-name {
  position: absolute;
  bottom: -1px;
  left: 0;
  background: #ffffff;
  width: 100%;
  padding: 0.5rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  transition: transform 0.25s ease;
  transform: translateY(100%);
  z-index: 4;
}

.preview-wrapper:not([loading]).show-floating-elements .preview-toolbar {
  transform: translate(-50%, 0%);
  visibility: visible;
}
.preview-wrapper:not([loading]).show-floating-elements .preview-file-name {
  bottom: 0;
  transform: translateY(0%);
}
.preview-wrapper:not([loading]):has(.preview:focus-visible) {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-500-rgb), 0.25);
}

@media screen and (min-width: 992px) {
  .preview-wrapper {
    width: 148px;
    height: 148px;
  }
  .preview-wrapper.show-floating-elements .preview-badge {
    z-index: 1;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
